import { HttpHandlerFn, HttpRequest } from "@angular/common/http";

export function credentialsInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  return next(req.clone({ withCredentials: true }));
}
